"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseConnector = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
class BaseConnector {
    constructor(metadata, config) {
        this.metadata = metadata;
        this.config = config;
        this.emitter = new eventemitter3_1.default();
    }
    async connect() {
        if (this.adapter) {
            return this.adapter;
        }
        const adapters = await this._connect();
        this.adapter = adapters;
        return adapters;
    }
    async disconnect() {
        if (this.adapter) {
            this.emitter.emit("Disconnect", {});
            this.emitter.removeAllListeners();
            this.adapter = undefined;
        }
    }
    get isWallet() {
        return this.metadata.isWallet;
    }
    get name() {
        return this.metadata.name;
    }
    get displayName() {
        return this.metadata.displayName;
    }
    get adapter() {
        return this._adapter;
    }
    set adapter(adapter) {
        this._adapter = adapter;
    }
    async isAvailable() {
        return true;
    }
    on(event, callback) {
        this.emitter.on(event, callback);
    }
    off(event, callback) {
        this.emitter.off(event, callback);
    }
}
exports.BaseConnector = BaseConnector;
